import React, { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import tw, { css } from "twin.macro";
import { useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import {
	EmptyData,
	PageLoading,
	PageTitleNavigation,
	SearchComponent,
	SplitPane,
} from "../../components";
import { isEmpty } from "../../lib/helpers/helpers";
import MainLayout from "../../components/MainLayout/MainLayout";
import { Wrapper } from "../../lib/styles/styleLibrary";
import WeddingCard from "../../components/WeddingCard/WeddingCard";

export const active = (props) => css`
	${tw`font-bold uppercase shadow rounded-2xl min-w-min text-appTextDark inline-flex gap-2 items-center justify-center py-4 hover:(text-appTextDark bg-gray-100 border-none) active:(text-appTextDark  bg-gray-100 border-none) focus:(text-appTextDark  bg-gray-200 border-none)`}
	font-family: Poppins;
	background-color: rgba(151, 151, 189, 0.2);
	line-height: 12px;
	letter-spacing: 0.5px;
	font-size: 0.875rem;
	@media (max-width: 1217px) {
		font-size: 0.65rem;
	}
`;
export const inactive = (props) => css`
	${tw`font-medium uppercase shadow-sm rounded-2xl min-w-min text-appTextFaded inline-flex gap-2 items-center justify-center py-4 hover:(text-appTextDark bg-gray-100 border-none) active:(text-appTextDark  bg-gray-100 border-none) focus:(border-none  bg-gray-200)`}
	font-family: Poppins;
	background-color: rgba(166, 166, 175, 0.082);
	line-height: 12px;
	letter-spacing: 0.5px;
	font-size: 0.875rem;
	@media (max-width: 1217px) {
		font-size: 0.65rem;
	}
`;

const SearchPage = (props) => {
	const isMobile = useMediaQuery({ maxWidth: 1217 });
	const location = useLocation();
	const state = location.state;
	const [queryResult, setQueryResult] = useState([]);
	const [loading, setLoading] = useState(false);
	const [search, setSearch] = useState("");

	useEffect(() => {
		if (isEmpty(state?.routeData)) {
			return;
		}
		if (isEmpty(state?.searchQuery)) {
			return;
		}
		setQueryResult(state?.routeData);
		setSearch(state?.searchQuery);
	}, [state]);

	return (
		<MainLayout tw="relative">
			<Wrapper>
				<PageTitleNavigation title={"Search"} showBack />
				<SearchComponent
					setQueryResult={setQueryResult}
					setLoading={setLoading}
					setSearchText={setSearch}
				/>
				<SplitPane
					wrapDirection={"column"}
					mainHeightAdjust={isMobile ? "16rem" : "16rem"}
					leftHeightAdjust={isMobile ? "0rem" : "0rem"}
					left={
						<div>
							{!isEmpty(search) && (
								<h4 tw="font-bold text-lg">
									Showing search result for{" "}
									<span tw="text-appPink font-bold uppercase">
										{search}
									</span>
								</h4>
							)}
							<div tw="flex flex-row gap-4 flex-wrap w-full h-auto">
								{loading ? (
									<PageLoading />
								) : isEmpty(queryResult?.weddings) ? (
									<div tw="flex flex-row gap-4 flex-wrap w-full justify-center">
										<EmptyData
											description={
												"No result found for this search"
											}
										/>
									</div>
								) : (
									<div tw="flex flex-row gap-4 flex-wrap">
										{queryResult?.weddings?.map(
											(querydata, i) => {
												if (
													!querydata.is_wedding_visible_on_public_search
												) {
													return false;
												}
												return (
													<WeddingCard
														key={i}
														background={
															querydata?.story_cover_image_url
														}
														WeddingData={querydata}
														date={querydata.date}
														name={`${querydata.bride_firstname} ${querydata.groom_firstname}`}
														location={
															querydata.venue
														}
														details={querydata}
													/>
												);
											}
										)}
									</div>
								)}
							</div>
						</div>
					}
				/>
			</Wrapper>
		</MainLayout>
	);
};

export default SearchPage;
